/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import './style.less';

let dv = null;

class Word extends React.PureComponent {
  static propTypes = {
    index: PropTypes.number,
    item: PropTypes.object,
    mouseup: PropTypes.func,
    handleSounds: PropTypes.func,
    readWords: PropTypes.func,
  };
 
  state = {
    x: 0,
    y: 0,
    isDragging: false,
    isClick: false,
    offsetY: 0,
    offsetX: 0,
    oldX: 0,
    oldY: 0,
  };
  componentDidMount() {
    this.init();
  }

  componentWillUnmount() {
    this.removeEvent();
  }

  init = () => {
    dv = document.getElementById(`word${this.props.index}`);
    this.setState({
      x: dv.offsetLeft,
      y: dv.offsetTop,
      oldX: dv.offsetLeft,
      oldY: dv.offsetTop,
    }, () => {
      this.addEvent();
    });
  }

  addEvent = () => {
    const { index } = this.props;
    if (/Android|webOS|iPhone|iPod|iPad|BlackBerry/i.test(navigator.userAgent)) {
      document.getElementById(`word${index}`).addEventListener('touchstart', this.startDrag);
      window.addEventListener('touchmove', this.dragging);
      window.addEventListener('touchend', this.endDrag);
    } else {
      document.getElementById(`word${index}`).addEventListener('mousedown', this.startDrag);
      window.addEventListener('mousemove', this.dragging);
      window.addEventListener('mouseup', this.endDrag);
    }
  };

  removeEvent = () => {
    if (/Android|webOS|iPhone|iPod|iPad|BlackBerry/i.test(navigator.userAgent)) {
      window.removeEventListener('touchmove', this.dragging);
      window.removeEventListener('touchend', this.endDrag);
    } else {
      window.removeEventListener('mousemove', this.dragging);
      window.removeEventListener('mouseup', this.endDrag);
    }
  };

  startDrag = (e) => {
    e.stopPropagation();
    this.setState({
      oldX: e.currentTarget.offsetLeft,
      oldY: e.currentTarget.offsetTop,
      x: e.currentTarget.offsetLeft,
      y: e.currentTarget.offsetTop,
    });
    // 给阴影设置宽高
    dv = e.currentTarget;
    dv.parentNode.style.width === ''
      && (dv.parentNode.style.width = `${dv.parentNode.clientWidth}px`);
    let touch = null;
    if (e.touches) {
      touch = {
        clientX: e.touches[0].clientX,
        clientY: e.touches[0].clientY,
      };
    } else {
      touch = e;
    }
    // 获取左部和顶部的偏移量
    const offsetX = touch.clientX - dv.offsetLeft;
    const offsetY = touch.clientY - dv.offsetTop;
    this.setState({
      isClick: true,
      offsetX,
      offsetY,
    });
  };
  // dragging = (e) => {
  //   const { isClick, offsetX, offsetY } = this.state;
  //   if (isClick) {
  //     !dv.className.includes(' down')
  //     && document.querySelectorAll('.word.down').length < 1
  //     && (dv.className += ' down')
  //     && this.props.handleSounds();
  //     let touch = null;
  //     if (e.touches) {
  //       touch = {
  //         clientX: e.touches[0].clientX,
  //         clientY: e.touches[0].clientY,
  //       };
  //     } else {
  //       touch = e;
  //     }
  //     const x = touch.clientX - offsetX;
  //     const y = touch.clientY - offsetY;
  //     this.setState({ x, y, isDragging: true });
  //   }
  // };
  dragging = (e) => {
    if (!this.state.isClick) return;
    const { offsetX, offsetY } = this.state;
    !dv.className.includes(' down')
    && document.querySelectorAll('.word.down').length < 1
    && (dv.className += ' down')
    && this.props.handleSounds();
    let touch = null;
    if (e.touches) {
      touch = {
        clientX: e.touches[0].clientX,
        clientY: e.touches[0].clientY,
      };
    } else {
      touch = e;
    }
    const x = touch.clientX - offsetX;
    const y = touch.clientY - offsetY;
    this.setState({ x, y, isDragging: true });
   // 使用requestAnimationFrame来更新位置
   this.updatePosition(dv,x,y);
  };
  updatePosition(dv, newX, newY) {
    // 使用requestAnimationFrame来安排更新
    requestAnimationFrame(() => {
      dv.style.left = `${newX}px`;
      dv.style.top = `${newY}px`;
      console.log('request',newX,newY);
    });
  }

  endDrag = () => {
    const {
      oldX,
      oldY,
      x,
      y,
      isDragging
    } = this.state;
    this.setState({ isClick: false });
    if (isDragging) {
      this.setState({
        isDragging: false,
      }, () => {
        this.props.mouseup(dv, x, y, oldX, oldY);
      });
    }
  }


  readWords = (e) => {
    this.props.readWords(e.currentTarget.dataset.audio);
  };
// style={{ left: this.state.x, top: this.state.y }}
  render(){
    const { index, item } = this.props;
    return (
      <div
        className="word"
        id={`word${index}`}
        
        data-audio={item.audio}
        onClick={this.readWords}
      >
        <div className="word-left" />
        <div className="word-center">{item.val}</div>
        <div className="word-right" />
      </div>
    );
  };
};

export default Word;
